import { ApiResponseBody, BulkApiResponseBody } from '@boltenergy-be/shared'

// TYPES

export type NewResponse<T = undefined> = {
  success: boolean
  data?: T
  message?: string
  error?: string
}

export type BackendResponse<T = undefined> = (ApiResponseBody<T> | BulkApiResponseBody<T>) & {
  success: boolean
}

// ENUMS

export enum Methods {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST'
}
